export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suche"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klicken Sie, um auszuwählen, welche Spalten angezeigt werden sollen"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Angezeigte Spalten"])}
}